import React from "react";

const NotFound = () => {
  return (
    <div className="not-found text-PrimaryBlack">
      <h1>404 - Page Not Found</h1>
      <p>
        Sorry, the page you are looking for does not exist.{" "}
        <a href="/">Navigate to startpage. </a>
      </p>
    </div>
  );
};

export default NotFound;
